export const LETTERS_REPORTS = "LETTERS_REPORTS";
export const TLUSHI_PENSION = "TLUSHI_PENSION";
export const PENSION_REPORTS = "PENSION_REPORTS";
export const MAS_CONFIRMS = "MAS_CONFIRMS";
export const DOCS_101 = "DOCS_101";
